// extracted by mini-css-extract-plugin
module.exports = {"section_header":"summer-styles_section_header__2ZUtB","section_description":"summer-styles_section_description__V_448"};